/* eslint-disable no-unused-vars */
import { baseUrl, khglUrl, dicUrl } from '@/config/env'
import request from '@/router/axios'
export const loginByUsername = (username, password, code, randomStr) => {
  var grant_type = 'password'
  var scope = 'server'
  return request({
    url: '/oauth/token',
    headers: {
      'Authorization': 'Basic dG9wY29ubjp0b3Bjb25u'
    },
    method: 'post',
    params: { username, password, randomStr, code, grant_type, scope }
  })
}

export function loginBySocial(state, code) {
  var grant_type = 'mobile'
  var scope = 'server'
  return request({
    url: '/mobile/token',
    headers: {
      'Authorization': 'Basic dG9wY29ubjp0b3Bjb25u'
    },
    method: 'post',
    params: { mobile:state + '@' + code, grant_type, scope }
  })
}

export const getUserInfo = () => {
  return request({
    url: '/user/info',
    method: 'get'
  })
}

export const logout = (data) => {
  return request({
    url: '/user/logout',
    method: 'post',
    params: data
  })
}
